<div class="main-card-container">
    <div class="main-card-wrapper">
        <div class="h-100" (click)="onProductClick()" [innerHTML]="
        baseHtml() | interpolation : product : showCashpoint() : showPercentageDiscount() | safehtml
      "></div>

        @if (showCountdown()) { @if (remainingTime(); as remainingTime) { @if
        (remainingTime.remainingTime > 1000) {
        <!-- Hover state count-down -->
        <div class="timer-container">
            @if (productDealCountDown()?.description) {
            <p class="title">
                {{ productDealCountDown()?.description }}
            </p>
            }
            <div class="wrapper">
                <div class="block">
                    <span class="top">{{ remainingTime?.daysToToday }}</span>
                    <span class="bottom">{{ remainingTime.daysToToday > 1 ? 'Days' : 'Day' }}</span>
                </div>
                :
                <div class="block">
                    <span class="top">{{ remainingTime?.hoursToToday }}</span>
                    <span class="bottom">{{ remainingTime.hoursToToday > 1 ? 'Hours' : 'Hour' }}</span>
                </div>
                :
                <div class="block">
                    <span class="top">{{ remainingTime?.minutesToToday }}</span>
                    <span class="bottom"> {{ remainingTime.minutesToToday > 1 ? 'Mins' : 'Min' }}</span>
                </div>
                :
                <div class="block">
                    <span class="top">{{ remainingTime?.secondsToToday }}</span>
                    <span class="bottom">{{ remainingTime.secondsToToday > 1 ? 'Secs' : 'Sec' }}</span>
                </div>
            </div>
        </div>
        } } } @if (showAddToCart()) {
        <webstore-add-to-cart-action [productInput]="product" [isDisplayPlusImageInput]="true" (addToCartClicked$)="onAddToCartClicked($event)"></webstore-add-to-cart-action>
        }
    </div>

    @if (showCountdown() && remainingTime(); as remainingTime) {
    <!-- Time tag at the top -->
    @if (isMobile()) { @if (remainingTime.remainingTime > 1000) {
    <div class="badge">
        @if (productDealCountDown()?.description) {
        {{ productDealCountDown()?.badge_message + ' ' }}
        } @if (remainingTime.daysToToday) {
        {{ remainingTime.daysToToday }}
        }{{ remainingTime.daysToToday > 0 ? 'd :' : '' }}
        @if (remainingTime.hoursToToday) {
        {{ remainingTime.hoursToToday }}
        }{{ remainingTime.hoursToToday > 0 ? 'h :' : '' }} {{ remainingTime.minutesToToday }}m :
        {{ remainingTime.secondsToToday }}s
    </div>
    } } @else { @if (remainingTime.daysToToday > 0) {
    <div class="badge">
        {{
      productDealCountDown()?.badge_message +
        ' ' +
        remainingTime.daysToToday +
        (remainingTime.daysToToday > 1 ? ' Days' : ' Day')
    }}
    </div>
    } @else if (remainingTime.daysToToday < 1 && remainingTime.hoursToToday>= 1) {
        <div class="badge">
            {{
      productDealCountDown()?.badge_message +
        ' ' +
        remainingTime.hoursToToday +
        (remainingTime.hoursToToday > 1 ? ' Hours' : ' Hour')
    }}
        </div>
        } @else if (remainingTime.daysToToday < 1 && remainingTime.hoursToToday < 1 && remainingTime.minutesToToday>= 1) {
            <div class="badge">
                {{
      productDealCountDown()?.badge_message +
        ' ' +
        remainingTime.minutesToToday +
        (remainingTime.minutesToToday > 1 ? ' Minutes' : ' Minute')
    }}
            </div>
            } @else if (remainingTime.daysToToday < 1 && remainingTime.hoursToToday < 1 && remainingTime.minutesToToday < 1 && remainingTime.secondsToToday>= 1) {
                <div class="badge">
                    {{
      productDealCountDown()?.badge_message +
        ' ' +
        remainingTime.secondsToToday +
        (remainingTime.secondsToToday > 1 ? ' Seconds' : ' Second')
    }}
                </div>
                } } }
</div>